import styled from 'styled-components';

export const UnsubscribePageContainer = styled.main`
    h3 {
        font-size: 22px;
        text-transform: none;
        margin-bottom: 30px;
        font-weight: ${props => props.theme.boldWeight};
    }

    p {
        margin-bottom: 50px;
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/unsubscribe/UnsubscribePageStyle.js